const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const COLORS = ["#1a5fe0", "#0f172a", "#0f766e", "#b91c1c", "#c2410c", "#7c2d12", "#a16207", "#15803d"];

export const cardHtml = ({ name, title, phone, email, address, logo, qr }) => `
<div class="card">
  <div class="l">
    ${logo ? `<img class="logo" src="${esc(logo)}" />` : `<div class="mono">${esc((name || "S").slice(0, 1))}</div>`}
    <div class="n">${esc(name)}</div>${title ? `<div class="t">${esc(title)}</div>` : ""}
    <div class="ln">${phone ? `<div>☎ ${esc(phone)}</div>` : ""}${email ? `<div>✉ ${esc(email)}</div>` : ""}${address ? `<div>⌂ ${esc(address)}</div>` : ""}</div>
  </div>
  <div class="r"><div class="qr">${qr}</div><div class="cap">Online teklif al</div></div>
</div>`;

export const backHtml = ({ name, logo, branches }) => `
<div class="card back">
  ${logo ? `<img class="blogo" src="${esc(logo)}" />` : `<div class="bname">${esc(name)}</div>`}
  <div class="bh">Sigorta hizmetlerimiz</div>
  <div class="bl">${branches.map((b) => `<span>${esc(b)}</span>`).join("")}</div>
</div>`;

const CSS = (c) => `
*{box-sizing:border-box}body{margin:0;font-family:'DM Sans',system-ui,-apple-system,Segoe UI,sans-serif;color:#0f172a;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.card{width:85mm;height:55mm;display:flex;padding:4.5mm;background:#fff;border-left:2.2mm solid ${c};overflow:hidden;page-break-inside:avoid}
.l{flex:1;min-width:0;display:flex;flex-direction:column}.logo{max-height:calc(15mm * var(--fs));max-width:calc(38mm * var(--fs));object-fit:contain;align-self:flex-start;margin-bottom:2mm}
.mono{width:9mm;height:9mm;border-radius:2mm;background:${c};color:#fff;display:grid;place-items:center;font-weight:800;font-size:5mm;margin-bottom:2mm}
.n{font-weight:800;font-size:3.9mm;line-height:1.15}.t{font-size:2.6mm;color:${c};font-weight:600;margin-top:.6mm}
.ln{margin-top:auto;font-size:2.35mm;color:#334155;line-height:1.45}.ln div{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.r{width:25mm;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1.2mm;padding-left:3mm;border-left:.2mm dashed #cbd5e1}
.qr svg{width:22mm;height:22mm;display:block}.cap{font-size:2.2mm;font-weight:700;color:${c};text-align:center}
.back{flex-direction:column;align-items:center;justify-content:center;text-align:center;border-left:0;background:${c};color:#fff;gap:2.2mm}
.blogo{max-height:calc(22mm * var(--bs));max-width:calc(55mm * var(--bs));object-fit:contain;background:#fff;border-radius:1.5mm;padding:1mm}.bname{font-weight:800;font-size:4mm}
.bh{font-size:2.4mm;letter-spacing:.4mm;text-transform:uppercase;opacity:.85;font-weight:700}
.bl{display:flex;flex-wrap:wrap;justify-content:center;gap:1.3mm;max-width:74mm}.bl span{font-size:2.5mm;font-weight:600;border:.25mm solid #ffffff99;border-radius:5mm;padding:.7mm 2.2mm}
.pg{page-break-after:always}.pg:last-child{page-break-after:auto}
.sheet{width:210mm;padding:13.5mm 15mm;display:grid;grid-template-columns:repeat(2,85mm);grid-auto-rows:55mm;gap:0 10mm;justify-content:center}
.sheet .card{outline:.2mm dashed #94a3b8}`;

export const openPrint = ({ front, back, color, sheet, fs = 1, bs = 1 }) => {
  const win = window.open("", "_blank");
  if (!win) return;
  const page = `:root{--fs:${fs};--bs:${bs}}` + (sheet ? "@page{size:A4;margin:0}" : "@page{size:85mm 55mm;margin:0}");
  const wrap = (c) => (sheet ? `<div class="pg"><div class="sheet">${Array(10).fill(c).join("")}</div></div>` : `<div class="pg">${c}</div>`);
  const body = wrap(front) + (back ? wrap(back) : "");
  win.document.open();
  win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Kartvizit</title><style>${CSS(color)}${page}</style></head><body>${body}<script>window.onload=()=>setTimeout(()=>window.print(),400)</script></body></html>`);
  win.document.close();
};
